// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kore-chat-window .kore-chat-body .tab-list-template {
  width: 100%;
  z-index: 9;
}

.kore-chat-window .kore-chat-body .tab-list-template .sheetHeader {
  height: 50px;
  width: 100%;
  padding: 10px;
  margin-bottom: 10px;
}

.kore-chat-window .kore-chat-body .tab-list-template .sheetHeader .choose {
  /* margin-left:11px; */
  width: 135px;
  height: 20px;
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  /* line-height: 2.3; */
  letter-spacing: normal;
  color: var(--sdk-chat-widow-primary-font-color);
  padding: 10px;
  padding-bottom: 0;
}

.kore-chat-window .kore-chat-body .tab-list-template .sheetHeader .listViewItemSubtitle {
  padding: 0;
  margin: 0 0 0 10px;
  white-space: normal;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.27px;
  color: var(--sdk-chat-widow-secondary-font-color);
}

.kore-chat-window .kore-chat-body .tab-list-template .sheetHeader .headerLeft {
  width: 70%;
  float: left;
}

.kore-chat-window .kore-chat-body .tab-list-template .sheetHeader .headerRight {
  width: 27%;
  vertical-align: middle;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: right;
  float: left;
}

.kore-chat-window .kore-chat-body .tab-list-template .sheetHeader .headerRight .headerActionBTN {
  background: var(--sdk-chat-widow-btn-light-color);
  color: var(--sdk-chat-widow-primary-blue-color);
  position: relative;
  max-width: 110px;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  /* text-transform: uppercase; */
  line-height: 32px;
  padding: 0 10px;
  display: block;
  height: 32px;
  border-radius: 4px;
  margin: 0;
  float: right;
}

.kore-chat-window .kore-chat-body .tab-list-template .sheetHeader .headerRight .headerActionLink {
  cursor: pointer;
  line-height: 14px;
  font-size: 14px;
  color: var(--sdk-chat-widow-primary-blue-color);
  display: block;
  /* border-bottom: 1px solid var(--sdk-chat-widow-primary-blue-color-opacity); */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-top: 10px;
}

.kore-chat-window .kore-chat-body .tab-list-template .sheetHeader .headerRight .headerActionEllipsis {
  width: 23px;
  height: 32px;
  background: var(--sdk-chat-widow-default-white);
  display: block;
  border-radius: 4px;
  text-align: center;
  padding-top: 10px;
  cursor: pointer;
  position: relative;
  top: auto;
  right: auto;
  left: auto;
  bottom: 0;
  margin: 0;
}

.kore-chat-window .kore-chat-body .tab-list-template .listViewLeftContent .titleDesc {
  /* display: inline-block;
  width: 100%; */
  display: table-cell;
  width: 100%;
}

.kore-chat-window .kore-chat-body .tab-list-template .listViewLeftContent .titleDesc.paddTop6 {
  padding-top: 6px;
}

.kore-chat-window .kore-chat-body .tab-list-template .titleActions {
  display: table-cell;
  vertical-align: middle;
  text-align: right;
  width: 25%;
}

.kore-chat-window .kore-chat-body .tab-list-template .titleActions.imageValue .wid-temp-btnImage {
  width: 16px;
  height: 16px;
  display: inline-block;
  cursor: pointer;
}

.kore-chat-window .kore-chat-body .tab-list-template .titleActions.imageValue .wid-temp-btnImage img {
  max-width: 100%;
}

/* added */
.kore-chat-window .kore-chat-body .tab-list-template .titleActions.center .wid-temp-btnImage {
  width: 16px;
  height: 16px;
  display: inline-block;
  cursor: pointer;
}

.kore-chat-window .kore-chat-body .tab-list-template .titleActions.center .wid-temp-btnImage img {
  max-width: 100%;
}

/* added */
.kore-chat-window .kore-chat-body .tab-list-template .titleActions .actionLink {
  cursor: pointer;
  line-height: 14px;
  font-size: 14px;
  color: var(--sdk-chat-widow-primary-blue-color);
  display: inline-block;
  border-bottom: 1px solid var(--sdk-chat-widow-primary-blue-color-opacity);
}

.kore-chat-window .kore-chat-body .tab-list-template .titleActions.top {
  vertical-align: top;
}

.kore-chat-window .kore-chat-body .tab-list-template .titleActions.center {
  vertical-align: middle;
}

.kore-chat-window .kore-chat-body .tab-list-template .titleActions.bottom {
  vertical-align: bottom;
}

.kore-chat-window .kore-chat-body .tab-list-template .sheetHeader .close-button {
  margin: 0;
  padding-top: 8px;
  cursor: pointer;
}

.kore-chat-window .kore-chat-body .tab-list-template .sheetHeader .close-button {
  cursor: pointer;
  color: var(--sdk-chat-widow-primary-blue-color);
  background: none;
  border: none;
  float: right;
  line-height: inherit;
  margin-right: 5px;
  margin-top: 17px;
  padding: 0 6px;
}

.kore-chat-window .kore-chat-body .tab-list-template .sheetHeader .headerLink {
  font-size: 14px;
  cursor: pointer;
  color: var(--sdk-chat-widow-primary-blue-color);
  margin-right: 5px;
  margin-top: 17px;
  padding: 0 6px;
  background: none;
  border: none;
  float: right;
}

.kore-chat-window .kore-chat-body .tab-list-template .sheetHeader .close-button img {
  cursor: pointer;
  background: none;
  border: none;
  outline: none;
  position: absolute;
  top: 21px;
  right: 20px;
}

.kore-chat-window .kore-chat-body .tab-list-template .listTemplateContainer {
  padding: 0 10px 10px 10px;
}

.kore-chat-window .kore-chat-body .tab-list-template .listTemplateContainer .listViewMore {
  cursor: pointer;
  font-size: 14px;
  line-height: 1.53;
  letter-spacing: normal;
  border-top: 1px solid var(--sdk-chat-widow-primary-border-color);
  /* padding-top: 5px; */
  margin-left: 10px;
  color: var(--sdk-chat-widow-primary-blue-color);
  text-align: right;
}

.kore-chat-window .kore-chat-body .tab-list-template .listTemplateContainer .listViewMore .seeMoreText {
  border-bottom: 1px solid var(--sdk-chat-widow-primary-blue-color);
  margin-bottom: 10px;
  display: inline-block;
  margin-top: 10px;
}

.kore-chat-window .kore-chat-body .tab-list-template .listViewMore .see-more {
  width: 4px;
  height: 8px;
  margin-left: 5px;
  background-image: var(--sdk-show-more);
  position: relative;
  top: 7px;
  float: right;
}

.kore-chat-window .kore-chat-body .tab-list-template .listTemplateContainer .tabsContainer {
  width: 100%;
  display: flex;
  text-align: center;
  margin-bottom: 12px;
  padding: 0 10px;
  /* height:40px; */
  /* overflow:auto; */
}

.kore-chat-window .kore-chat-body .tab-list-template .listTemplateContainer .displayListValues {
  padding: 10px 5px 0 5px;
  list-style: none;
  /* position: relative; */
  margin: 0;
}

.kore-chat-window .kore-chat-body .tab-list-template .listTemplateContainer .tabsContainer .tabs {
  /* width: 18px;
          height: 17px; */
  /* flex: 1 1 auto; */
  /* font-family: Lato; */
  font-size: 14px;
  font-weight: normal;
  letter-spacing: 0.12px;
  color: var(--sdk-chat-widow-secondary-font-color);
  /* padding-left:103px; */
  cursor: pointer;
  max-width: 170px;
}

.kore-chat-window .kore-chat-body .tab-list-template .listTemplateContainer .tabsContainer .tabs .btnBG {
  /* background: rgba(0, 157, 171, .1); */
  padding: 5px 10px;
  border-radius: 6px;
  display: block;
}

.kore-chat-window .kore-chat-body .tab-list-template .listTemplateContainer .tabsContainer .tabs.active .btnBG {
  background: var(--sdk-chat-widow-btn-light-color);
  color: var(--sdk-chat-widow-primary-blue-color);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
}

.kore-chat-window .kore-chat-body .tab-list-template .listTemplateContainer .listViewRightContent img {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  /* border: 1px solid var( --sdk-chat-widow-primary-border-color); */
}

.kore-chat-window .kore-chat-body .tab-list-template .listTemplateContainer .displayListValues .listViewRightContent {
  /* position: absolute; */
  display: table-cell;
  vertical-align: top;
}

.kore-chat-window .kore-chat-body .tab-list-template .listTemplateContainer .displayListValues .listViewLeftContent {
  /* min-height: 40px;
  display: block;
  margin-right: 25%; */
  display: table-cell;
  vertical-align: top;
  padding-left: 10px;
  padding-right: 10px;
  width: 100%;
}

.kore-chat-window .kore-chat-body .pie-chart-template .tab-list-template .listTemplateContainer .displayListValues .listViewLeftContent {
  padding: 0;
}

.kore-chat-window .kore-chat-body .pie-chart-template .tab-list-template .listViewTmplContentChild .meetingActionButtons .actionBtns {
  margin-right: 0;
}

.kore-chat-window .kore-chat-body .tab-list-template .listTemplateContainer .displayListValues .listViewLeftContent.marginRightZero {
  margin-right: 0;
}

.kore-chat-window .kore-chat-body .tab-list-template .listTemplateContainer .displayListValues .listViewLeftContent.paddingLeft55 {
  padding-left: 55px;
}

.kore-chat-window .kore-chat-body .tab-list-template .listTemplateContainer .displayListValues .listViewLeftContent .listViewItemTitle {
  /* padding: 3px 0; */
  /* width: 154px; */
  /* height: 22px; */
  font-size: 14px;
  font-weight: 900;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.4px;
  color: var(--sdk-chat-widow-primary-font-color);
  /* max-width: 90%; */
  /* white-space: nowrap; */
  /* overflow: hidden; */
  /* text-overflow: ellipsis; */
}

.kore-chat-window .kore-chat-body .tab-list-template .listTemplateContainer .displayListValues .listViewLeftContent .listViewItemSubtitle {
  /* max-width: 90%; */
  padding: 3px 0;
  white-space: pre-wrap;
  /* overflow: hidden;
  text-overflow: ellipsis; */
  font-size: 12px;
  font-weight: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: 0.27px;
  color: var(--sdk-chat-widow-secondary-font-color);
}

.kore-chat-window .kore-chat-body .tab-list-template .listTemplateContainer .displayListValues .listViewLeftContent .listViewItemValue {
  display: inline-block;
  width: 24%;
  font-size: 16px;
  font-weight: 800;
  letter-spacing: 0.4px;
  text-align: right;
  color: var(--sdk-chat-widow-primary-font-color);
  overflow: hidden;
  text-overflow: ellipsis;
  position: absolute;
  top: 2px;
  right: 0;
  white-space: normal;
}

.kore-chat-window .kore-chat-body .tab-list-template .listTemplateContainer .displayListValues .listViewLeftContent .listViewItemValue.top10 {
  top: 10px;
}

.kore-chat-window .kore-chat-body .tab-list-template .listViewTmplContentChild .meetingActionButtons.float {
  font-size: 23px;
  margin-top: 10px;
  /* float: left; */
  display: inline-block;
  /* justify-content: center; */
  width: 100%;
  padding: 10px 0 0;
  position: relative;
}

.kore-chat-window .kore-chat-body .tab-list-template .listViewTmplContentChild .meetingActionButtons.hide {
  display: none;
}

.kore-chat-window .kore-chat-body .tab-list-template .listViewTmplContentChild .meetingActionButtons.float .actionBtns {
  flex: none;
  float: left;
  padding: 0 10px;
  border-radius: 4px;
  margin-right: 7px;
  margin-top: 10px;
  cursor: pointer;
  border: 0;
  letter-spacing: 1.24px;
  font-weight: bold;
  height: 32px;
  background: var(--sdk-chat-widow-btn-light-color);
  color: var(--sdk-chat-widow-primary-blue-color);
  font-size: 10px;
  text-transform: uppercase;
  text-align: center;
  width: auto;
  min-width: 100px;
  max-width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  line-height: 34px;
}

.kore-chat-window .kore-chat-body .tab-list-template .listViewTmplContentChild .meetingActionButtons {
  font-size: 23px;
  margin-top: 10px;
  /* float: left; */
  display: flex;
  /* justify-content: center; */
  width: 100%;
  padding: 10px 0 0;
  position: relative;
}

.kore-chat-window .kore-chat-body .menuItemCntr {
  height: 100%;
}

.kore-chat-window .kore-chat-body .tab-list-template .listViewTmplContentChild .meetingActionButtons .actionBtns {
  flex: 1 1 auto;
  /* float: none; */
  padding: 0 10px;
  border-radius: 4px;
  margin-right: 7px;
  cursor: pointer;
  border: 0;
  letter-spacing: 1.24px;
  font-weight: bold;
  height: 32px;
  background: var(--sdk-chat-widow-btn-light-color);
  color: var(--sdk-chat-widow-primary-blue-color);
  font-size: 10px;
  text-transform: uppercase;
  text-align: center;
  width: auto;
  /* min-width: 100px; */
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  line-height: 34px;
}

.kore-chat-window .kore-chat-body .tab-list-template .listViewTmplContentChild .meetingActionButtons .actionBtns .wid-temp-btnImage {
  margin-right: 5px;
  position: relative;
  top: 3px;
  display: inline-block;
  width: 15px;
  height: 15px;
  padding: 0;
}

.kore-chat-window .kore-chat-body .tab-list-template .listViewTmplContentChild .meetingActionButtons .actionBtns .wid-temp-btnImage img {
  width: 100%;
  display: inline-block;
}

.kore-chat-window .kore-chat-body .tab-list-template .listViewTmplContentChild .meetingActionButtons .actionBtns.dropbtnWidgt {
  bottom: auto;
  position: relative;
  /* margin: 10px 0 0; */
}

.kore-chat-window .kore-chat-body .tab-list-template .listViewTmplContentChild .meetingActionButtons.float .actionBtns.dropbtnWidgt {
  bottom: auto;
  position: relative;
  margin: 10px 0 0;
}

.kore-chat-window .kore-chat-body .listViewTmplContentChild .meetingActionButtons .dropdown-contentWidgt {
  bottom: 50px;
  max-height: 200px;
  border: 1px solid var(--sdk-chat-widow-primary-border-color);
  overflow-y: auto;
}

.kore-chat-window .kore-chat-body .tab-list-template .listViewTmplContentChild .wid-temp-showMoreBottom {
  bottom: 0;
  position: absolute;
  z-index: 1;
  background: rgba(38, 52, 74, 0.2);
  width: 100%;
  left: 0;
  border-bottom-left-radius: 11px;
  border-bottom-right-radius: 11px;
  height: 100%;
}

.kore-chat-window .kore-chat-body .tab-list-template .listViewTmplContentChild .wid-temp-showMoreBottom .showMoreContainer {
  background: var(--sdk-chat-widow-default-white);
  width: 100%;
  left: 0;
  box-shadow: var(--sdk-chat-widow-top-box-shadow);
  bottom: 0;
  position: absolute;
}

.kore-chat-window .kore-chat-body .tab-list-template .listViewTmplContentChild .wid-temp-showMoreBottom .headerTitleMore {
  font-size: 18px;
  font-weight: bold;
  color: var(--sdk-chat-widow-primary-font-color);
  padding: 20px;
}

.kore-chat-window .kore-chat-body .tab-list-template .listViewTmplContentChild .wid-temp-showMoreBottom .moreItemsScroll {
  max-height: 200px;
  overflow-y: auto;
  padding: 0px 20px 20px 20px;
}

.kore-chat-window .kore-chat-body .tab-list-template .listViewTmplContentChild .wid-temp-showMoreBottom .headerTitleMore .wid-temp-showMoreClose {
  float: right;
}

.kore-chat-window .kore-chat-body .tab-list-template .listViewTmplContentChild .wid-temp-showMoreBottom .headerTitleMore .wid-temp-showMoreClose .closeCross {
  height: 26px;
  width: 26px;
  background: var(--sdk-chat-widow-default-white);
  cursor: pointer;
  padding: 5px;
  border-radius: 50%;
}

.kore-chat-window .kore-chat-body .tab-list-template .listViewTmplContentChild .wid-temp-showMoreBottom .headerTitleMore .wid-temp-showMoreClose .closeCross:hover {
  height: 26px;
  width: 26px;
  background: var(--sdk-primary-bg-color);
}

.kore-chat-window .kore-chat-body .tab-list-template .listViewTmplContentChild .wid-temp-showMoreBottom .wid-temp-contentDiv {
  /* margin-bottom: 8px; */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 22px;
}

.kore-chat-window .kore-chat-body .tab-list-template .listViewTmplContentChild .wid-temp-showMoreBottom .wid-temp-contentDiv .wid-temp-discImage {
  padding-right: 15px;
  display: inline-block;
  width: 17px;
  height: 17px;
  margin-right: 10px;
  padding: 0;
  position: relative;
  top: -3px;
}

.kore-chat-window .kore-chat-body .tab-list-template .listViewTmplContentChild .wid-temp-showMoreBottom .wid-temp-contentDiv .wid-temp-discription {
  font-size: 12px;
  font-weight: 500;
  color: var(--sdk-chat-widow-primary-font-color);
  display: inline-block;
  max-width: 80%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.kore-chat-window .kore-chat-body .tab-list-template .listViewTmplContentChild .wid-temp-showMoreBottom .wid-temp-contentDiv .wid-temp-discImage img {
  width: 100%;
  display: inline-block;
}

.kore-chat-window .kore-chat-body .tab-list-template .listViewTmplContentChild .wid-temp-showMoreBottom .wid-temp-contentDiv .wid-temp-showActions {
  float: right;
}

.kore-chat-window .kore-chat-body .tab-list-template .listViewTmplContentChild .wid-temp-showMoreBottom .wid-temp-contentDiv .wid-temp-showActions .accordionIcon-darkMode {
  width: 20px;
  height: 20px;
  cursor: pointer;
  display: none;
}

.kore-chat-window .kore-chat-body .tab-list-template .listViewTmplContentChild .wid-temp-showMoreBottom .wid-temp-contentDiv .wid-temp-showActions .accordionIcon {
  width: 20px;
  height: 20px;
  cursor: pointer;
  display: block;
}

.kore-chat-window .kore-chat-body .tab-list-template .listViewTmplContentChild {
  border-bottom: 1px solid var(--sdk-chat-widow-primary-border-color);
  margin-bottom: 10px;
  /* position: relative; */
  padding-bottom: 10px;
}

.kore-chat-window .kore-chat-body .tab-list-template .listViewTmplContentChild:nth-last-child(1) {
  border-bottom: 0;
  margin-bottom: 0;
}

.kore-chat-window .kore-chat-body .tab-list-template .listViewTmplContentChild .listViewTmplContentChildRow {
  display: block;
  background-color: var(--sdk-chat-widow-default-white);
  width: 100%;
  position: relative;
  cursor: pointer;
}

.kore-chat-window .kore-chat-body .tab-list-template .listViewTmplContentChild .tabListViewDiscription {
  margin-top: 15px;
  padding-left: 3px;
}

.kore-chat-window .kore-chat-body .tab-list-template .listViewTmplContentChild .tabListViewDiscription .wid-temp-contentDiv {
  /* margin-bottom: 8px; */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 22px;
}

.kore-chat-window .kore-chat-body .tab-list-template .listViewTmplContentChild .tabListViewDiscription .wid-temp-contentDiv .wid-temp-showActions {
  float: right;
  background-image: var(--sdk-accordion-icon);
  width: 20px;
  height: 20px;
  cursor: pointer;
  position: relative;
  top: 4px;
}

.kore-chat-window .kore-chat-body .tab-list-template .listViewTmplContentChild .tabListViewDiscription .wid-temp-contentDiv .wid-temp-showActions.active {
  transform: rotate(180deg);
}

.kore-chat-window .kore-chat-body .tab-list-template .listViewTmplContentChild .tabListViewDiscription .wid-temp-contentDiv .wid-temp-discImage {
  padding-right: 15px;
  display: inline-block;
  width: 17px;
  height: 17px;
  margin-right: 10px;
  padding: 0;
  position: relative;
  top: -3px;
}

.kore-chat-window .kore-chat-body .tab-list-template .listViewTmplContentChild .tabListViewDiscription .wid-temp-contentDiv .wid-temp-discImage img {
  width: 100%;
  display: inline-block;
}

.kore-chat-window .kore-chat-body .tab-list-template .listViewTmplContentChild .tabListViewDiscription .wid-temp-contentDiv .wid-temp-discription {
  font-size: 12px;
  font-weight: 500;
  color: var(--sdk-chat-widow-primary-font-color);
  display: inline-block;
  max-width: 80%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.kore-chat-window .kore-chat-body .tab-list-template .listViewTmplContentChild .tabListViewDiscription .wid-temp-showMore {
  cursor: pointer;
  line-height: 14px;
  font-size: 14px;
  color: var(--sdk-chat-widow-primary-blue-color);
  display: inline-block;
  padding: 10px 0 5px;
  border-bottom: 1px solid var(--sdk-chat-widow-primary-blue-color-opacity);
  /* margin-bottom: 10px; */
}

.kore-chat-window .kore-chat-body .tab-list-template .listViewTmplContentChild .tabListViewDiscription .wid-temp-showMore .show-more {
  width: 4px;
  height: 8px;
  margin-left: 5px;
  background-image: var(--sdk-show-more);
  position: relative;
  top: 4px;
  float: right;
}

/*-- Tabbedlist -ended   ---*/
.kore-chat-window .kore-chat-body .listTemplateContainer .show {
  display: block;
  bottom: 50px;
}

.kore-chat-window .kore-chat-body .sheetHeader .show {
  display: block;
  margin-right: 30px;
}`, "",{"version":3,"sources":["webpack://./src/plugins/v2Plugin/templates/listWidgetTemplate/listWidgetTemplate.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,UAAA;AACJ;;AAGA;EACI,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;AAAJ;;AAGA;EACI,sBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,sBAAA;EACA,sBAAA;EACA,+CAAA;EACA,aAAA;EACA,iBAAA;AAAJ;;AAEA;EACI,UAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,iDAAA;AACJ;;AACA;EACI,UAAA;EACA,WAAA;AAEJ;;AAAA;EACI,UAAA;EACA,sBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;AAGJ;;AAAA;EACI,iDAAA;EACA,+CAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,+BAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;AAGJ;;AADA;EACI,eAAA;EACA,iBAAA;EACA,eAAA;EACA,+CAAA;EACA,cAAA;EACA,+EAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AAIJ;;AAFA;EACI,WAAA;EACA,YAAA;EACA,+CAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;AAKJ;;AAHA;EACI;gBAAA;EAEA,mBAAA;EACA,WAAA;AAMJ;;AAJA;EACI,gBAAA;AAOJ;;AALA;EACI,mBAAA;EACA,sBAAA;EACA,iBAAA;EACA,UAAA;AAQJ;;AANA;EACI,WAAA;EACA,YAAA;EACA,qBAAA;EACA,eAAA;AASJ;;AAPA;EACI,eAAA;AAUJ;;AAPA,UAAA;AACA;EACI,WAAA;EACA,YAAA;EACA,qBAAA;EACA,eAAA;AAUJ;;AARA;EACI,eAAA;AAWJ;;AATA,UAAA;AACA;EACI,eAAA;EACA,iBAAA;EACA,eAAA;EACA,+CAAA;EACA,qBAAA;EACA,yEAAA;AAYJ;;AAVA;EACI,mBAAA;AAaJ;;AAXA;EACI,sBAAA;AAcJ;;AAZA;EACI,sBAAA;AAeJ;;AAbA;EACI,SAAA;EACA,gBAAA;EACA,eAAA;AAgBJ;;AAbA;EACI,eAAA;EACA,+CAAA;EACA,gBAAA;EACA,YAAA;EACA,YAAA;EACA,oBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AAgBJ;;AAbA;EACI,eAAA;EACA,eAAA;EACA,+CAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,YAAA;EACA,YAAA;AAgBJ;;AAbA;EACI,eAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;AAgBJ;;AAbA;EACI,yBAAA;AAgBJ;;AAdA;EACI,eAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,gEAAA;EACA,sBAAA;EACA,iBAAA;EACA,+CAAA;EACA,iBAAA;AAiBJ;;AAfA;EACI,iEAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;AAkBJ;;AAhBA;EACI,UAAA;EACA,WAAA;EACA,gBAAA;EACA,sCAAA;EACA,kBAAA;EACA,QAAA;EACA,YAAA;AAmBJ;;AAjBA;EACI,WAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AAoBJ;;AAjBA;EACI,uBAAA;EACA,gBAAA;EACA,wBAAA;EACA,SAAA;AAoBJ;;AAjBA;EACI;yBAAA;EAEA,oBAAA;EACA,uBAAA;EACA,eAAA;EACA,mBAAA;EACA,sBAAA;EACA,iDAAA;EACA,wBAAA;EACA,eAAA;EACA,gBAAA;AAoBJ;;AAjBA;EACI,uCAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AAoBJ;;AAjBA;EACI,iDAAA;EACA,+CAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;AAoBJ;;AAjBA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mEAAA;AAoBJ;;AAjBA;EACI,wBAAA;EACA,mBAAA;EACA,mBAAA;AAoBJ;;AAhBA;EACI;;sBAAA;EAGA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;AAmBJ;;AAjBA;EACG,UAAA;AAoBH;;AAlBA;EACI,eAAA;AAqBJ;;AAnBA;EACI,eAAA;AAsBJ;;AApBA;EACI,kBAAA;AAuBJ;;AArBA;EACI,oBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,qBAAA;EACA,+CAAA;EACA,oBAAA;EACA,yBAAA;EACA,sBAAA;EACA,6BAAA;AAwBJ;;AArBA;EACI,oBAAA;EACA,cAAA;EACA,qBAAA;EACA;4BAAA;EAEA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,iDAAA;AAwBJ;;AArBA;EACI,qBAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,iBAAA;EACA,+CAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,QAAA;EACA,QAAA;EACA,mBAAA;AAwBJ;;AAtBA;EACI,SAAA;AAyBJ;;AAtBA;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,6BAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;AAyBJ;;AAvBA;EACI,aAAA;AA0BJ;;AAtBA;EACI,UAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,SAAA;EACA,sBAAA;EACA,iBAAA;EACA,YAAA;EACA,iDAAA;EACA,+CAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AAyBJ;;AAtBA;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,6BAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;AAyBJ;;AAvBA;EACI,YAAA;AA0BJ;;AAxBA;EACI,cAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,SAAA;EACA,sBAAA;EACA,iBAAA;EACA,YAAA;EACA,iDAAA;EACA,+CAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AA2BJ;;AArBA;EACI,iBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;AAwBJ;;AAtBA;EACI,WAAA;EACA,qBAAA;AAyBJ;;AAvBA;EACI,YAAA;EACA,kBAAA;EACA,sBAAA;AA0BJ;;AAxBA;EACI,YAAA;EACA,kBAAA;EACA,gBAAA;AA2BJ;;AAzBA;EACI,YAAA;EACA,iBAAA;EACA,4DAAA;EACA,gBAAA;AA4BJ;;AA1BA;EACI,SAAA;EACA,kBAAA;EACA,UAAA;EACA,iCAAA;EACA,WAAA;EACA,OAAA;EACA,+BAAA;EACA,gCAAA;EACA,YAAA;AA6BJ;;AA3BA;EACI,+CAAA;EACA,WAAA;EACA,OAAA;EACA,gDAAA;EACA,SAAA;EACA,kBAAA;AA8BJ;;AA5BA;EACI,eAAA;EACA,iBAAA;EACA,+CAAA;EACA,aAAA;AA+BJ;;AA7BA;EACI,iBAAA;EACA,gBAAA;EACA,2BAAA;AAgCJ;;AA9BA;EACI,YAAA;AAiCJ;;AA9BA;EACI,YAAA;EACA,WAAA;EACA,+CAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;AAiCJ;;AA9BA;EACI,YAAA;EACA,WAAA;EACA,uCAAA;AAiCJ;;AA9BA;EACI,wBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;AAiCJ;;AA9BA;EACI,mBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,SAAA;AAiCJ;;AA/BA;EACI,eAAA;EACA,gBAAA;EACA,+CAAA;EACA,qBAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAkCJ;;AAhCA;EACI,WAAA;EACA,qBAAA;AAmCJ;;AAjCA;EACI,YAAA;AAoCJ;;AAjCA;EACI,WAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;AAoCJ;;AAjCA;EACI,WAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;AAoCJ;;AAjCA;EACI,mEAAA;EACA,mBAAA;EACA,wBAAA;EACA,oBAAA;AAoCJ;;AAlCA;EACI,gBAAA;EACA,gBAAA;AAqCJ;;AAnCA;EACI,cAAA;EACA,qDAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;AAsCJ;;AAnCA;EACI,gBAAA;EACA,iBAAA;AAsCJ;;AAnCA;EACI,wBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;AAsCJ;;AAnCA;EACI,YAAA;EACA,2CAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,QAAA;AAsCJ;;AAnCA;EACI,yBAAA;AAsCJ;;AAnCA;EACI,mBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,SAAA;AAsCJ;;AAnCA;EACI,WAAA;EACA,qBAAA;AAsCJ;;AAnCA;EACI,eAAA;EACA,gBAAA;EACA,+CAAA;EACA,qBAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAsCJ;;AAnCA;EACI,eAAA;EACA,iBAAA;EACA,eAAA;EACA,+CAAA;EACA,qBAAA;EACA,mBAAA;EACA,yEAAA;EACA,yBAAA;AAsCJ;;AAnCA;EACI,UAAA;EACA,WAAA;EACA,gBAAA;EACA,sCAAA;EACA,kBAAA;EACA,QAAA;EACA,YAAA;AAsCJ;;AApCA,6BAAA;AACA;EACI,cAAA;EACA,YAAA;AAuCJ;;AArCA;EACI,cAAA;EACF,kBAAA;AAwCF","sourcesContent":[".kore-chat-window .kore-chat-body .tab-list-template {\n    width: 100%;\n    z-index: 9;\n\n}\n\n.kore-chat-window .kore-chat-body .tab-list-template .sheetHeader {\n    height: 50px;\n    width: 100%;\n    padding: 10px;\n    margin-bottom: 10px;\n}\n\n.kore-chat-window .kore-chat-body .tab-list-template .sheetHeader .choose {\n    /* margin-left:11px; */\n    width: 135px;\n    height: 20px;\n    font-size: 18px;\n    font-weight: bold;\n    font-stretch: normal;\n    font-style: normal;\n    /* line-height: 2.3; */\n    letter-spacing: normal;\n    color: var(--sdk-chat-widow-primary-font-color);\n    padding: 10px;\n    padding-bottom: 0;\n}\n.kore-chat-window .kore-chat-body .tab-list-template .sheetHeader .listViewItemSubtitle {\n    padding: 0;\n    margin: 0 0 0 10px;\n    white-space: normal;\n    font-size: 13px;\n    font-weight: normal;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: normal;\n    letter-spacing: 0.27px;\n    color: var(--sdk-chat-widow-secondary-font-color);\n}\n.kore-chat-window .kore-chat-body .tab-list-template .sheetHeader .headerLeft{\n    width: 70%;\n    float: left;\n}\n.kore-chat-window .kore-chat-body .tab-list-template .sheetHeader .headerRight{\n    width: 27%;\n    vertical-align: middle;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    text-align: right;\n    float: left;\n   \n}\n.kore-chat-window .kore-chat-body .tab-list-template .sheetHeader .headerRight .headerActionBTN{\n    background: var(--sdk-chat-widow-btn-light-color);\n    color: var(--sdk-chat-widow-primary-blue-color);\n    position: relative;\n    max-width: 110px;\n    text-align: center;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    font-size: 12px;\n    /* text-transform: uppercase; */\n    line-height: 32px;\n    padding: 0 10px;\n    display: block;\n    height: 32px;\n    border-radius: 4px;\n    margin: 0;\n    float: right;\n}\n.kore-chat-window .kore-chat-body .tab-list-template .sheetHeader .headerRight .headerActionLink{\n    cursor: pointer;\n    line-height: 14px;\n    font-size: 14px;\n    color: var(--sdk-chat-widow-primary-blue-color);\n    display: block;\n    /* border-bottom: 1px solid var(--sdk-chat-widow-primary-blue-color-opacity); */\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    margin-top: 10px;\n}\n.kore-chat-window .kore-chat-body .tab-list-template .sheetHeader .headerRight .headerActionEllipsis{\n    width: 23px;\n    height: 32px;\n    background: var(--sdk-chat-widow-default-white);\n    display: block;\n    border-radius: 4px;\n    text-align: center;\n    padding-top: 10px;\n    cursor: pointer;\n    position: relative;\n    top: auto;\n    right: auto;\n    left: auto;\n    bottom: 0;\n    margin: 0;\n}\n.kore-chat-window .kore-chat-body .tab-list-template .listViewLeftContent .titleDesc {\n    /* display: inline-block;\n    width: 100%; */\n    display: table-cell;\n    width: 100%;\n}\n.kore-chat-window .kore-chat-body .tab-list-template .listViewLeftContent .titleDesc.paddTop6{\n    padding-top: 6px;\n}\n.kore-chat-window .kore-chat-body .tab-list-template .titleActions{\n    display: table-cell;\n    vertical-align: middle;\n    text-align: right;\n    width: 25%;\n}\n.kore-chat-window .kore-chat-body .tab-list-template .titleActions.imageValue .wid-temp-btnImage{\n    width: 16px;\n    height: 16px;\n    display: inline-block;\n    cursor: pointer;\n}\n.kore-chat-window .kore-chat-body .tab-list-template .titleActions.imageValue .wid-temp-btnImage img{\n    max-width: 100%;\n}\n\n/* added */\n.kore-chat-window .kore-chat-body .tab-list-template .titleActions.center .wid-temp-btnImage{\n    width: 16px;\n    height: 16px;\n    display: inline-block;\n    cursor: pointer;\n}\n.kore-chat-window .kore-chat-body .tab-list-template .titleActions.center .wid-temp-btnImage img{\n    max-width: 100%;\n}\n/* added */\n.kore-chat-window .kore-chat-body .tab-list-template .titleActions .actionLink{\n    cursor: pointer;\n    line-height: 14px;\n    font-size: 14px;\n    color: var(--sdk-chat-widow-primary-blue-color);\n    display: inline-block;\n    border-bottom: 1px solid var(--sdk-chat-widow-primary-blue-color-opacity);\n}\n.kore-chat-window .kore-chat-body .tab-list-template .titleActions.top{\n    vertical-align: top;\n}\n.kore-chat-window .kore-chat-body .tab-list-template .titleActions.center{\n    vertical-align: middle;\n}\n.kore-chat-window .kore-chat-body .tab-list-template .titleActions.bottom{\n    vertical-align: bottom;\n}\n.kore-chat-window .kore-chat-body .tab-list-template .sheetHeader .close-button {\n    margin: 0;\n    padding-top: 8px;\n    cursor: pointer;\n}\n\n.kore-chat-window .kore-chat-body .tab-list-template .sheetHeader .close-button {\n    cursor: pointer;\n    color: var(--sdk-chat-widow-primary-blue-color);\n    background: none;\n    border: none;\n    float: right;\n    line-height: inherit;\n    margin-right: 5px;\n    margin-top: 17px;\n    padding: 0 6px;\n}\n\n.kore-chat-window .kore-chat-body .tab-list-template .sheetHeader .headerLink {\n    font-size: 14px;\n    cursor: pointer;\n    color: var(--sdk-chat-widow-primary-blue-color);\n    margin-right: 5px;\n    margin-top: 17px;\n    padding: 0 6px;\n    background: none;\n    border: none;\n    float: right;\n}\n\n.kore-chat-window .kore-chat-body .tab-list-template .sheetHeader .close-button img {\n    cursor: pointer;\n    background: none;\n    border: none;\n    outline: none;\n    position: absolute;\n    top: 21px;\n    right: 20px;\n}\n\n.kore-chat-window .kore-chat-body .tab-list-template .listTemplateContainer {\n    padding: 0 10px 10px 10px;\n}\n.kore-chat-window .kore-chat-body .tab-list-template .listTemplateContainer .listViewMore{\n    cursor: pointer;\n    font-size: 14px;\n    line-height: 1.53;\n    letter-spacing: normal;\n    border-top: 1px solid var(--sdk-chat-widow-primary-border-color);\n    /* padding-top: 5px; */\n    margin-left: 10px;\n    color: var(--sdk-chat-widow-primary-blue-color);\n    text-align: right;\n}\n.kore-chat-window .kore-chat-body .tab-list-template .listTemplateContainer .listViewMore .seeMoreText{\n    border-bottom: 1px solid var(--sdk-chat-widow-primary-blue-color);\n    margin-bottom: 10px;\n    display: inline-block;\n    margin-top: 10px;\n}\n.kore-chat-window .kore-chat-body .tab-list-template .listViewMore .see-more {\n    width: 4px;\n    height: 8px;\n    margin-left: 5px;\n    background-image: var(--sdk-show-more);\n    position: relative;\n    top: 7px;\n    float: right;\n}\n.kore-chat-window .kore-chat-body .tab-list-template .listTemplateContainer .tabsContainer {\n    width: 100%;\n    display: flex;\n    text-align: center;\n    margin-bottom: 12px;\n    padding: 0 10px;\n    /* height:40px; */\n    /* overflow:auto; */\n}\n\n.kore-chat-window .kore-chat-body .tab-list-template .listTemplateContainer .displayListValues {\n    padding: 10px 5px 0 5px;\n    list-style: none;\n    /* position: relative; */\n    margin: 0;\n}\n\n.kore-chat-window .kore-chat-body .tab-list-template .listTemplateContainer .tabsContainer .tabs {\n    /* width: 18px;\n            height: 17px; */\n    /* flex: 1 1 auto; */\n    /* font-family: Lato; */\n    font-size: 14px;\n    font-weight: normal;\n    letter-spacing: 0.12px;\n    color: var(--sdk-chat-widow-secondary-font-color);\n    /* padding-left:103px; */\n    cursor: pointer;\n    max-width: 170px;\n}\n\n.kore-chat-window .kore-chat-body .tab-list-template .listTemplateContainer .tabsContainer .tabs .btnBG {\n    /* background: rgba(0, 157, 171, .1); */\n    padding: 5px 10px;\n    border-radius: 6px;\n    display: block;\n}\n\n.kore-chat-window .kore-chat-body .tab-list-template .listTemplateContainer .tabsContainer .tabs.active .btnBG {\n    background: var(--sdk-chat-widow-btn-light-color);\n    color: var(--sdk-chat-widow-primary-blue-color);\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    display: block;\n}\n\n.kore-chat-window .kore-chat-body .tab-list-template .listTemplateContainer .listViewRightContent img {\n    width: 40px;\n    height: 40px;\n    border-radius: 8px;\n    /* border: 1px solid var( --sdk-chat-widow-primary-border-color); */\n}\n\n.kore-chat-window .kore-chat-body .tab-list-template .listTemplateContainer .displayListValues .listViewRightContent {\n    /* position: absolute; */\n    display: table-cell;\n    vertical-align: top;\n    \n}\n\n.kore-chat-window .kore-chat-body .tab-list-template .listTemplateContainer .displayListValues .listViewLeftContent {\n    /* min-height: 40px;\n    display: block;\n    margin-right: 25%; */\n    display: table-cell;\n    vertical-align: top;\n    padding-left: 10px;\n    padding-right: 10px;\n    width: 100%;\n}\n.kore-chat-window .kore-chat-body .pie-chart-template .tab-list-template .listTemplateContainer .displayListValues .listViewLeftContent {\n   padding: 0;\n}\n.kore-chat-window .kore-chat-body .pie-chart-template  .tab-list-template .listViewTmplContentChild .meetingActionButtons .actionBtns{\n    margin-right:0; \n}\n.kore-chat-window .kore-chat-body .tab-list-template .listTemplateContainer .displayListValues .listViewLeftContent.marginRightZero{\n    margin-right:0;\n}\n.kore-chat-window .kore-chat-body .tab-list-template .listTemplateContainer .displayListValues .listViewLeftContent.paddingLeft55{\n    padding-left: 55px;\n}\n.kore-chat-window .kore-chat-body .tab-list-template .listTemplateContainer .displayListValues .listViewLeftContent .listViewItemTitle {\n    /* padding: 3px 0; */\n    /* width: 154px; */\n    /* height: 22px; */\n    font-size: 14px;\n    font-weight: 900;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: normal;\n    letter-spacing: 0.4px;\n    color: var(--sdk-chat-widow-primary-font-color);\n    /* max-width: 90%; */\n    /* white-space: nowrap; */\n    /* overflow: hidden; */\n    /* text-overflow: ellipsis; */\n}\n\n.kore-chat-window .kore-chat-body .tab-list-template .listTemplateContainer .displayListValues .listViewLeftContent .listViewItemSubtitle {\n    /* max-width: 90%; */\n    padding: 3px 0;\n    white-space: pre-wrap;\n    /* overflow: hidden;\n    text-overflow: ellipsis; */\n    font-size: 12px;\n    font-weight: normal;\n    font-style: normal;\n    line-height: 1.5;\n    letter-spacing: 0.27px;\n    color: var(--sdk-chat-widow-secondary-font-color);\n}\n\n.kore-chat-window .kore-chat-body .tab-list-template .listTemplateContainer .displayListValues .listViewLeftContent .listViewItemValue {\n    display: inline-block;\n    width: 24%;\n    font-size: 16px;\n    font-weight: 800;\n    letter-spacing: 0.4px;\n    text-align: right;\n    color: var(--sdk-chat-widow-primary-font-color);\n    overflow: hidden;\n    text-overflow: ellipsis;\n    position: absolute;\n    top: 2px;\n    right: 0;\n    white-space: normal;\n}\n.kore-chat-window .kore-chat-body .tab-list-template .listTemplateContainer .displayListValues .listViewLeftContent .listViewItemValue.top10{\n    top: 10px;\n}\n\n.kore-chat-window .kore-chat-body .tab-list-template .listViewTmplContentChild .meetingActionButtons.float {\n    font-size: 23px;\n    margin-top: 10px;\n    /* float: left; */\n    display: inline-block;\n    /* justify-content: center; */\n    width: 100%;\n    padding: 10px 0 0;\n    position: relative;\n}\n.kore-chat-window .kore-chat-body .tab-list-template .listViewTmplContentChild .meetingActionButtons.hide{\n    display: none;\n}\n\n\n.kore-chat-window .kore-chat-body .tab-list-template .listViewTmplContentChild .meetingActionButtons.float .actionBtns {\n    flex: none;\n    float: left;\n    padding: 0 10px;\n    border-radius: 4px;\n    margin-right: 7px;\n    margin-top: 10px;\n    cursor: pointer;\n    border: 0;\n    letter-spacing: 1.24px;\n    font-weight: bold;\n    height: 32px;\n    background: var(--sdk-chat-widow-btn-light-color);\n    color: var(--sdk-chat-widow-primary-blue-color);\n    font-size: 10px;\n    text-transform: uppercase;\n    text-align: center;\n    width: auto;\n    min-width: 100px;\n    max-width: 100%;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    line-height: 34px;\n}\n\n.kore-chat-window .kore-chat-body .tab-list-template .listViewTmplContentChild .meetingActionButtons {\n    font-size: 23px;\n    margin-top: 10px;\n    /* float: left; */\n    display: flex;\n    /* justify-content: center; */\n    width: 100%;\n    padding: 10px 0 0;\n    position: relative;\n}\n.kore-chat-window .kore-chat-body .menuItemCntr{\n    height: 100%;\n  }\n.kore-chat-window .kore-chat-body .tab-list-template .listViewTmplContentChild .meetingActionButtons .actionBtns {\n    flex: 1 1 auto;\n    /* float: none; */\n    padding: 0 10px;\n    border-radius: 4px;\n    margin-right: 7px;\n    cursor: pointer;\n    border: 0;\n    letter-spacing: 1.24px;\n    font-weight: bold;\n    height: 32px;\n    background: var(--sdk-chat-widow-btn-light-color);\n    color: var(--sdk-chat-widow-primary-blue-color);\n    font-size: 10px;\n    text-transform: uppercase;\n    text-align: center;\n    width: auto;\n    /* min-width: 100px; */\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    line-height: 34px;\n}\n\n\n\n\n.kore-chat-window .kore-chat-body .tab-list-template .listViewTmplContentChild .meetingActionButtons .actionBtns .wid-temp-btnImage{\n    margin-right: 5px;\n    position: relative;\n    top: 3px;\n    display: inline-block;\n    width: 15px;\n    height: 15px;\n    padding: 0;\n}\n.kore-chat-window .kore-chat-body .tab-list-template .listViewTmplContentChild .meetingActionButtons .actionBtns .wid-temp-btnImage img{\n    width: 100%;\n    display: inline-block;\n}\n.kore-chat-window .kore-chat-body .tab-list-template .listViewTmplContentChild .meetingActionButtons .actionBtns.dropbtnWidgt {\n    bottom: auto;\n    position: relative;\n    /* margin: 10px 0 0; */\n}\n.kore-chat-window .kore-chat-body .tab-list-template .listViewTmplContentChild .meetingActionButtons.float .actionBtns.dropbtnWidgt {\n    bottom: auto;\n    position: relative;\n    margin: 10px 0 0;\n}\n.kore-chat-window .kore-chat-body .listViewTmplContentChild .meetingActionButtons .dropdown-contentWidgt {\n    bottom: 50px;\n    max-height: 200px;\n    border: 1px solid var(--sdk-chat-widow-primary-border-color);\n    overflow-y: auto;\n}\n.kore-chat-window .kore-chat-body .tab-list-template .listViewTmplContentChild .wid-temp-showMoreBottom {\n    bottom: 0;\n    position: absolute;\n    z-index: 1;\n    background: rgba(38, 52, 74, 0.2);\n    width: 100%;\n    left: 0;\n    border-bottom-left-radius: 11px;\n    border-bottom-right-radius: 11px;\n    height: 100%;\n}\n.kore-chat-window .kore-chat-body .tab-list-template .listViewTmplContentChild .wid-temp-showMoreBottom .showMoreContainer{\n    background: var(--sdk-chat-widow-default-white);\n    width: 100%;\n    left: 0;\n    box-shadow: var(--sdk-chat-widow-top-box-shadow);\n    bottom: 0;\n    position: absolute;\n}\n.kore-chat-window .kore-chat-body .tab-list-template .listViewTmplContentChild .wid-temp-showMoreBottom .headerTitleMore {\n    font-size: 18px;\n    font-weight: bold;\n    color: var(--sdk-chat-widow-primary-font-color);\n    padding: 20px;\n}\n.kore-chat-window .kore-chat-body .tab-list-template .listViewTmplContentChild .wid-temp-showMoreBottom .moreItemsScroll {\n    max-height: 200px;\n    overflow-y: auto;\n    padding: 0px 20px 20px 20px;\n}\n.kore-chat-window .kore-chat-body .tab-list-template .listViewTmplContentChild .wid-temp-showMoreBottom .headerTitleMore .wid-temp-showMoreClose {\n    float: right;\n}\n\n.kore-chat-window .kore-chat-body .tab-list-template .listViewTmplContentChild .wid-temp-showMoreBottom .headerTitleMore .wid-temp-showMoreClose .closeCross {\n    height: 26px;\n    width: 26px;\n    background: var(--sdk-chat-widow-default-white);\n    cursor: pointer;\n    padding: 5px;\n    border-radius: 50%;\n}\n\n.kore-chat-window .kore-chat-body .tab-list-template .listViewTmplContentChild .wid-temp-showMoreBottom .headerTitleMore .wid-temp-showMoreClose .closeCross:hover {\n    height: 26px;\n    width: 26px;\n    background: var(--sdk-primary-bg-color);\n}\n\n.kore-chat-window .kore-chat-body .tab-list-template .listViewTmplContentChild .wid-temp-showMoreBottom .wid-temp-contentDiv {\n    /* margin-bottom: 8px; */\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    line-height: 22px;\n}\n\n.kore-chat-window .kore-chat-body .tab-list-template .listViewTmplContentChild .wid-temp-showMoreBottom .wid-temp-contentDiv .wid-temp-discImage {\n    padding-right: 15px;\n    display: inline-block;\n    width: 17px;\n    height: 17px;\n    margin-right: 10px;\n    padding: 0;\n    position: relative;\n    top: -3px;\n}\n.kore-chat-window .kore-chat-body .tab-list-template .listViewTmplContentChild .wid-temp-showMoreBottom .wid-temp-contentDiv .wid-temp-discription{\n    font-size: 12px;\n    font-weight: 500;\n    color: var(--sdk-chat-widow-primary-font-color);\n    display: inline-block;\n    max-width: 80%;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n.kore-chat-window .kore-chat-body .tab-list-template .listViewTmplContentChild .wid-temp-showMoreBottom .wid-temp-contentDiv .wid-temp-discImage img{\n    width: 100%;\n    display: inline-block;\n}\n.kore-chat-window .kore-chat-body .tab-list-template .listViewTmplContentChild .wid-temp-showMoreBottom .wid-temp-contentDiv .wid-temp-showActions {\n    float: right;\n}\n\n.kore-chat-window .kore-chat-body .tab-list-template .listViewTmplContentChild .wid-temp-showMoreBottom .wid-temp-contentDiv .wid-temp-showActions .accordionIcon-darkMode {\n    width: 20px;\n    height: 20px;\n    cursor: pointer;\n    display: none;\n}\n\n.kore-chat-window .kore-chat-body .tab-list-template .listViewTmplContentChild .wid-temp-showMoreBottom .wid-temp-contentDiv .wid-temp-showActions .accordionIcon {\n    width: 20px;\n    height: 20px;\n    cursor: pointer;\n    display: block;\n}\n\n.kore-chat-window .kore-chat-body .tab-list-template .listViewTmplContentChild {\n    border-bottom: 1px solid var(--sdk-chat-widow-primary-border-color);\n    margin-bottom: 10px;\n    /* position: relative; */\n    padding-bottom: 10px;\n}\n.kore-chat-window .kore-chat-body .tab-list-template .listViewTmplContentChild:nth-last-child(1){\n    border-bottom: 0;\n    margin-bottom: 0;\n}\n.kore-chat-window .kore-chat-body .tab-list-template .listViewTmplContentChild .listViewTmplContentChildRow {\n    display: block;\n    background-color: var(--sdk-chat-widow-default-white);\n    width: 100%;\n    position: relative;\n    cursor: pointer;\n}\n\n.kore-chat-window .kore-chat-body .tab-list-template .listViewTmplContentChild .tabListViewDiscription {\n    margin-top: 15px;\n    padding-left: 3px;\n}\n\n.kore-chat-window .kore-chat-body .tab-list-template .listViewTmplContentChild .tabListViewDiscription .wid-temp-contentDiv {\n    /* margin-bottom: 8px; */\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    line-height: 22px;\n}\n\n.kore-chat-window .kore-chat-body .tab-list-template .listViewTmplContentChild .tabListViewDiscription .wid-temp-contentDiv .wid-temp-showActions {\n    float: right;\n    background-image: var(--sdk-accordion-icon);\n    width: 20px;\n    height: 20px;\n    cursor: pointer;\n    position: relative;\n    top: 4px;\n}\n\n.kore-chat-window .kore-chat-body .tab-list-template .listViewTmplContentChild .tabListViewDiscription .wid-temp-contentDiv .wid-temp-showActions.active {\n    transform: rotate(180deg);\n}\n\n.kore-chat-window .kore-chat-body .tab-list-template .listViewTmplContentChild .tabListViewDiscription .wid-temp-contentDiv .wid-temp-discImage {\n    padding-right: 15px;\n    display: inline-block;\n    width: 17px;\n    height: 17px;\n    margin-right: 10px;\n    padding: 0;\n    position: relative;\n    top: -3px;\n}\n\n.kore-chat-window .kore-chat-body .tab-list-template .listViewTmplContentChild .tabListViewDiscription .wid-temp-contentDiv .wid-temp-discImage img {\n    width: 100%;\n    display: inline-block;\n}\n\n.kore-chat-window .kore-chat-body .tab-list-template .listViewTmplContentChild .tabListViewDiscription .wid-temp-contentDiv .wid-temp-discription {\n    font-size: 12px;\n    font-weight: 500;\n    color: var(--sdk-chat-widow-primary-font-color);\n    display: inline-block;\n    max-width: 80%;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.kore-chat-window .kore-chat-body .tab-list-template .listViewTmplContentChild .tabListViewDiscription .wid-temp-showMore {\n    cursor: pointer;\n    line-height: 14px;\n    font-size: 14px;\n    color: var(--sdk-chat-widow-primary-blue-color);\n    display: inline-block;\n    padding: 10px 0 5px;\n    border-bottom: 1px solid var(--sdk-chat-widow-primary-blue-color-opacity);\n    /* margin-bottom: 10px; */\n}\n\n.kore-chat-window .kore-chat-body .tab-list-template .listViewTmplContentChild .tabListViewDiscription .wid-temp-showMore .show-more {\n    width: 4px;\n    height: 8px;\n    margin-left: 5px;\n    background-image: var(--sdk-show-more);\n    position: relative;\n    top: 4px;\n    float: right;\n}\n/*-- Tabbedlist -ended   ---*/\n.kore-chat-window .kore-chat-body .listTemplateContainer .show {\n    display: block;\n    bottom: 50px;\n}\n.kore-chat-window .kore-chat-body .sheetHeader .show {\n    display: block;\n  margin-right:30px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
